import {
    GET_TRANSFER_ORDER_BY_ID,
    SET_TRANSFER_ORDER_BY_ID,
    CREATE_TRANSFER_ORDER_REQUEST
} from "./TransferOrderByIdType"

const getTransferOrderById = (val : any) => ({
    type: GET_TRANSFER_ORDER_BY_ID,
    val
});

const setTransferOrderById = (transferOrderByIdData: any) => ({
    type: SET_TRANSFER_ORDER_BY_ID,
    transferOrderByIdData: transferOrderByIdData
});

const createTransferRequest = (transferOrderRequest: any) => ({
    type: CREATE_TRANSFER_ORDER_REQUEST,
    transferOrderRequest
});

export {
    getTransferOrderById,
    setTransferOrderById,
    createTransferRequest
}
